import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import { Grid, Paper, Button } from '@mui/material';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
// import { mainListItems, secondaryListItems } from './listItems';
import { secondaryListItems } from 'src/components/Dashboard/Menu/listItems';
import Chart from './Chart'
import Deposits from './Deposits';
import Orders from './Orders';
import Asset_table from 'src/components/Dashboard/AssetManager/Asset_table';

import EarthMap from 'src/components/Dashboard/Map/Earth_map';
import AreaChart from 'src/components/Dashboard/Area_chart';
import Line_chart from 'src/components/Dashboard/Graphs/Line_chart';

import BarChart from 'src/components/Dashboard/Bar_chart';
import ChangePassword from 'src/components/Forms/ChangePassword';

import TokenService from "src/services/token";
import { useNavigate } from "react-router-dom";

import {
    setUserMessage, resetStore
} from 'src/reducers/basicReducer';
import { useDispatch } from 'react-redux';
import Variable_selector from './Map/Variable_selector';

import { useAppSelector, useAppDispatch } from 'src/hooks';
import {
    getAssets,
    deleteAssets
} from 'src/reducers/basicReducer';

import type { AppDispatch } from 'src/store'

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://robotenlightenment.com/">
                Robot Enlightenment
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const drawerWidth: number = 240;

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

const mdTheme = createTheme();

function DashboardContent() {
    const [open, setOpen] = React.useState(true);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    // https://stackoverflow.com/questions/50644976/react-button-onclick-redirect-page
    let navigate = useNavigate();
    // https://stackoverflow.com/questions/70143816/argument-of-type-asyncthunkactionany-void-is-not-assignable-to-paramete
    // https://stackoverflow.com/questions/72163276/why-argument-of-type-asyncthunkactionany-void-is-not-assignable-to-par
    let dispatch = useDispatch<AppDispatch>();

    // looks like we use the logout function in SignOut.tsx. TODO - figure out what's up with the version below!
    // I think it's for the logout button in the dashboard itself (not the menu). Not sure it's needed...
    const logout = () => {
        console.log("before reset");
        dispatch(resetStore());
        console.log("after reset");
        dispatch(setUserMessage("Log out successful")); // TODO - consider if this message should disappear when user hits "sign in" button (even if invalid)
        console.log("NAVIGATING TO LOGIN 3");
        TokenService.removeUser();
        navigate("/login");
    }

    const clear_all_assets = () => {
        dispatch(deleteAssets());
        return null;
    }

    return (
        <ThemeProvider theme={mdTheme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar position="absolute" open={open}>
                    <Toolbar
                        sx={{
                            pr: '24px', // keep right padding when drawer closed
                        }}
                    >
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={toggleDrawer}
                            sx={{
                                marginRight: '36px',
                                ...(open && { display: 'none' }),
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            sx={{ flexGrow: 1 }}
                        >
                            Climate Analytics
                        </Typography>
                        {/* <IconButton color="inherit">
                            <Badge badgeContent={4} color="secondary">
                                <NotificationsIcon />
                            </Badge>
                        </IconButton> */}
                    </Toolbar>
                </AppBar>
                <Drawer variant="permanent" open={open}>
                    <Toolbar
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            px: [1],
                        }}
                    >
                        <IconButton onClick={toggleDrawer}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </Toolbar>
                    <Divider />
                    <List component="nav">
                        {/* {mainListItems}
                        <Divider sx={{ my: 1 }} /> */}
                        {secondaryListItems}
                    </List>
                </Drawer>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <Toolbar />
                    {/* was using maxWidth="lg", but I think it looks nice to use the entire avaiable space:
                    https://mui.com/material-ui/api/container/
                    note: could add "disableGutters={true}" to use even more space */}
                    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
                        <Grid container spacing={3}> {/* max width is 12; xs = extra small, md = medium, lg = large */}
                            {/* Variable selector */}
                            <Grid item xs={12}>
                                <Variable_selector />
                            </Grid>
                            {/* Main map */}
                            <Grid item xs={12}>
                                <EarthMap />
                            </Grid>
                            <Grid item xs={12}>
                                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                                    <Asset_table />
                                </Paper>
                            </Grid>
                            <Grid container item xs={12} justifyContent="center">
                                <Line_chart />
                            </Grid>
                            <Grid container item xs={6} justifyContent="center">
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <BarChart />
                                </Paper>
                            </Grid>
                            <Grid container item xs={6} justifyContent="center">
                                <AreaChart />
                            </Grid>
                            <Grid container item xs={4} justifyContent="center">
                                <Button variant="contained" onClick={logout} color="primary">
                                    Log out
                                </Button>
                                <Button variant="contained" onClick={clear_all_assets} color="primary">
                                    Delete assets
                                </Button>
                            </Grid>
                            {/* Chart */}
                            <Grid item xs={12} md={8} lg={9}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 240,
                                    }}
                                >
                                    <Chart />
                                </Paper>
                            </Grid>
                            {/* Recent Deposits */}
                            <Grid item xs={12} md={4} lg={3}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 240,
                                    }}
                                >
                                    <Deposits />
                                </Paper>
                            </Grid>
                            {/* Recent Orders */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                                    <Orders />
                                </Paper>
                            </Grid>
                        </Grid>
                        <Copyright sx={{ pt: 4 }} />
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
}

export default function Dashboard() {
    const dispatch = useAppDispatch();
    dispatch(getAssets());

    return <DashboardContent />;
}
